import { useEffect, useState } from 'react';

import { useAuthContext } from 'src/contexts/AuthProvider';

interface PermissionOption {
    value:
        | 'addPartner'
        | 'viewPartner'
        | 'editPartner'
        | 'changePartnerStatus'
        | 'addMerchant'
        | 'addService'
        | 'viewMerchant'
        | 'editMerchant'
        | 'cancelServices'
        | 'changeMerchantStatus'
        | 'unmaskPll'
        | 'leadManagement'
        | 'pricingAndProductManagement'
        | 'reportingExcludingFinance'
        | 'reportingIncludingFinance'
        | 'stockManagement'
        | 'viewFinance'
        | 'viewCommissions'
        | 'viewSelfBillingInvoices'
        | 'addInvoice'
        | 'addPayment'
        | 'addCredit'
        | 'partnerShop'
        | 'serviceDesk'
        | 'configurationUserManagement'
        | 'configurationAuditLog'
        | 'configurationFinance'
        | 'configurationSage'
        | 'managePartnerResources'
        | 'configurationPartnerResources'
        | 'configurationOther'
        | 'customerSuccess'
        | string;
}

const useHasPermission = (permission: PermissionOption['value']) => {
    const { user } = useAuthContext();
    const [hasPermission, setHasPermission] = useState<boolean>(true);

    useEffect(() => {
        if (permission && user?.role) {
            setHasPermission(!!user.role.permissions[0][permission]);
        } else {
            setHasPermission(true);
        }
    }, [permission, user]);

    return hasPermission;
};

export default useHasPermission;
